// extracted by mini-css-extract-plugin
module.exports = {"winnerSegment":"K6bW807","subHeader":"JLHTIUa"};